module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyBmb3IgeW91IHRvIGhhY2sgdGhlIGJhc2ljIHRva2VuIGNvbnRyYWN0IGJlbG93LgoKWW91IGFyZSBnaXZlbiBzb21lIHRva2VucyB0byBzdGFydCB3aXRoIGFuZCB5b3Ugd2lsbCBiZWF0IHRoZSBsZXZlbCBpZiB5b3Ugc29tZWhvdyBtYW5hZ2UgdG8gZ2V0IHlvdXIgaGFuZHMgb24gYW55IGFkZGl0aW9uYWwgdG9rZW5zLiBQcmVmZXJhYmx5IGEgdmVyeSBsYXJnZSBhbW91bnQgb2YgdG9rZW5zLgoKJm5ic3A7ClRoaW5ncyB0aGF0IG1pZ2h0IGhlbHA6CiogV2hhdCBpcyBhbiB1aW50Pwo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/bank.md
// module id = 1355
// module chunks = 0